<template>
  <div class="checkout-panel">
    <div style="display: flex; flex-direction: row; flex-wrap: wrap">
      <CheckoutPanelTitle :index="index" :title="title" />
      <CheckoutPanelMain v-if="$scopedSlots.main && !editing">
        <slot name="main" />
      </CheckoutPanelMain>
      <div
        v-if="$scopedSlots.main && $scopedSlots.secondary"
        style="position: absolute; top: 1.5rem; right: 1.5rem"
      >
        <button
          class="btn btn-primary"
          style="border-radius: 0.5rem; padding: 0.25rem 0.75rem"
          @click="handleClick"
        >
          <small>{{ editing ? "Cancel" : "Change" }}</small>
        </button>
      </div>
    </div>
    <CheckoutPanelSecondary
      v-if="$scopedSlots.secondary && editing"
      @handleClose="handleClick"
    >
      <slot name="secondary" />
    </CheckoutPanelSecondary>
  </div>
</template>

<script>
import CheckoutPanelMain from "./CheckoutPanelMain.vue";
import CheckoutPanelTitle from "./CheckoutPanelTitle.vue";
import CheckoutPanelSecondary from "./CheckoutPanelSecondary.vue";

export default {
  components: {
    CheckoutPanelMain,
    CheckoutPanelSecondary,
    CheckoutPanelTitle,
  },
  props: {
    index: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    editing: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    handleClick() {
      this.$emit("handleEditing");
    },
  },
};
</script>

<style>
.checkout-panel {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
}
</style>
